// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/loader-white.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app .list .content {
  /*
              .add {
                  text-align: center;
                  display: block;
                  padding: 6% 0;

                  span {
                      font: 1.3em/1 vigaregular;
                      text-decoration: none;
                      text-align: center;
                      color: #5c5c5c;
                      display: block;
                  }

                  img {
                      margin-top: 2%;
                      width: 8%;
                  }
              }
  */
}
.app .list .content .list-wrap {
  min-height: 150px;
}
.app .list .content .list-wrap.loading {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}
.app .list .content .list-wrap.loading * {
  visibility: hidden;
}
.app .list .content .actions {
  text-align: right;
  position: absolute;
  top: 20px;
  right: 5px;
}
.app .list .content .actions a, .app .list .content .actions div {
  display: inline-block;
  margin: 0 5px;
  cursor: pointer;
}
.app .list .content .actions a:last-child, .app .list .content .actions div:last-child {
  margin-right: 0;
}
.app .list .content .actions a span, .app .list .content .actions div span {
  color: #caa36a;
  font-size: 18px;
}
.app .list .content .actions a img, .app .list .content .actions div img {
  width: 100%;
  max-width: 18px;
}
.app .list .content .bottom-buttons {
  display: block;
  text-align: center;
  width: 100%;
  padding-bottom: 4%;
}
.app .list .content .bottom-btn {
  align-items: center;
  border: 1px solid #caa36a;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  margin: 10px 20px;
  padding: 12px;
  text-decoration: none;
  cursor: pointer;
}
.app .list .content .bottom-btn span {
  font: 1.3em/1 vigaregular;
  text-decoration: none;
  text-align: center;
  color: #5C5C5C;
}
.app .list .content .bottom-btn span.icon-add,
.app .list .content .bottom-btn span.icon-sort {
  font-size: 1.7em;
}
.app .list .content .bottom-btn img {
  margin-left: 5px;
  max-width: 12px;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/AdminDetail.scss"],"names":[],"mappings":"AAEQ;EAsCR;;;;;;;;;;;;;;;;;;;GAAA;AAnBA;AAlBY;EACI,iBAAA;AAoBhB;AAlBgB;EACI,2EAAA;AAoBpB;AAlBoB;EACI,kBAAA;AAoBxB;AAfY;EACI,iBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AAiBhB;AAfgB;EACI,qBAAA;EACA,aAAA;EACA,eAAA;AAiBpB;AAfoB;EACI,eAAA;AAiBxB;AAfoB;EACI,cAAA;EACA,eAAA;AAiBxB;AAdoB;EACI,WAAA;EACA,eAAA;AAgBxB;AAQY;EACI,cAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AANhB;AASY;EACI,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;AAPhB;AASgB;EACI,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,cAAA;AAPpB;AAUgB;;EAEI,gBAAA;AARpB;AAWgB;EACI,gBAAA;EACA,eAAA;AATpB","sourcesContent":[".app {\n    .list {\n        .content {\n            .list-wrap {\n                min-height: 150px;\n\n                &.loading {\n                    background: url(../../../public/images/loader-white.gif) no-repeat center center;\n\n                    * {\n                        visibility: hidden;\n                    }\n                }\n            }\n\n            .actions {\n                text-align: right;\n                position: absolute;\n                top: 20px;\n                right: 5px;\n\n                a, div {\n                    display: inline-block;\n                    margin: 0 5px;\n                    cursor: pointer;\n                    \n                    &:last-child {\n                        margin-right: 0;\n                    }\n                    span{\n                        color: #caa36a;\n                        font-size: 18px;\n                    }\n\n                    img {\n                        width: 100%;\n                        max-width: 18px;;\n                    }\n                }\n            }\n/*\n            .add {\n                text-align: center;\n                display: block;\n                padding: 6% 0;\n\n                span {\n                    font: 1.3em/1 vigaregular;\n                    text-decoration: none;\n                    text-align: center;\n                    color: #5c5c5c;\n                    display: block;\n                }\n\n                img {\n                    margin-top: 2%;\n                    width: 8%;\n                }\n            }\n*/\n            .bottom-buttons{\n                display: block;\n                text-align: center;\n                width: 100%;\n                padding-bottom: 4%;\n            }\n\n            .bottom-btn {\n                align-items: center;\n                border: 1px solid #caa36a;\n                border-radius: 8px;\n                display: flex;\n                justify-content: space-between;\n                margin: 10px 20px;\n                padding: 12px;\n                text-decoration: none;\n                cursor: pointer;\n\n                span {\n                    font: 1.3em/1 vigaregular;\n                    text-decoration: none;\n                    text-align: center;\n                    color: #5C5C5C;\n                }\n\n                span.icon-add,\n                span.icon-sort{\n                    font-size: 1.7em;\n                }\n\n                img {\n                    margin-left: 5px;\n                    max-width: 12px;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
